import { META_PIXEL_ID, CAPI_ENDPOINT } from './config'

/**
 * Safe tracking layer.
 * While META_PIXEL_ID is empty every function is a no-op that logs to the console.
 * No pixel ID, webhook, or endpoint is ever hardcoded here.
 */

type Props = Record<string, string | number | boolean | undefined>

let pixelInitialized = false

function pixelReady(): boolean {
  return Boolean(META_PIXEL_ID) && pixelInitialized
}

function send(event: string, props?: Props): void {
  if (!pixelReady()) {
    // eslint-disable-next-line no-console
    console.log('[tracking:no-op]', event, props ?? {})
    return
  }
  // Real pixel dispatch would go here once META_PIXEL_ID is filled:
  // window.fbq?.('trackCustom', event, props)
  // eslint-disable-next-line no-console
  console.log('[tracking]', event, props ?? {})
}

/** Initializes the pixel exactly once. Does nothing while META_PIXEL_ID is empty. */
export function initTracking(): void {
  if (pixelInitialized) return
  pixelInitialized = true
  if (!META_PIXEL_ID) {
    // eslint-disable-next-line no-console
    console.log('[tracking:no-op] init skipped — META_PIXEL_ID is empty')
    return
  }
  // Pixel bootstrap snippet goes here once META_PIXEL_ID is filled.
}

export const trackPageView = () => send('PageView')
export const trackHeaderCTA = () => send('HeaderCTA')
export const trackHeroCTA = () => send('HeroCTA')
export const trackFormView = () => send('FormView')
export const trackFormStart = () => send('FormStart')
export const trackVehicleInterest = (category: string) => send('VehicleInterest', { category })
export const trackLead = (props: Props) => send('Lead', props)
/** `queen` stays a tracked property so per-person routing can be measured later. */
export const trackWhatsAppContact = (queen: string, context: string) =>
  send('WhatsAppContact', { queen, context })
export const trackScrollDepth = (depth: 25 | 50 | 75 | 100) => send('ScrollDepth', { depth })
export const trackTimeOnPage = (seconds: 30 | 60 | 120) => send('TimeOnPage', { seconds })

/**
 * Server-side Meta Conversions API stub.
 * Uses the SAME eventId as the browser event so the two deduplicate.
 * Intentionally inert until CAPI_ENDPOINT is filled and a server route exists.
 */
export async function sendConversionsApiEvent(payload: {
  eventId: string
  [key: string]: unknown
}): Promise<void> {
  if (!CAPI_ENDPOINT) {
    // eslint-disable-next-line no-console
    console.log('[capi:no-op] CAPI_ENDPOINT is empty', payload.eventId)
    return
  }
  // await fetch(CAPI_ENDPOINT, {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify({ ...payload, event_name: 'Lead', event_id: payload.eventId }),
  // })
}
